import ExportIcon from "@material-ui/icons/GetApp";
import React from "react";
import { downloadBlob, ensureResponseOk } from "utils/download";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { httpClientRaw } from "../../../api/httpClient";
import { ProgressIcon } from "../../ProgressIcon";
import { fetchDataForExport } from "../ExportDialog/DataExportTable";
import { ToolbarButton } from "../ExportDialog/ToolbarButton";

const getFilenameFromResponse = (res, fallback) => {
	const contentDisposition = res.headers.get("content-disposition");
	if (!contentDisposition) return fallback;
	const match = contentDisposition.match(/filename=([^;]+)/);
	if (!match?.[1]) return fallback;
	return match[1].trim().replace(/['"]/g, "");
};

export const ExportServerButton = ({
	filters,
	label,
	type,
	endpoint,
	sort,
	filename,
	disabled,
}) => {
	const [loading, setLoading] = React.useState(false);
	const notifyError = useNotifyError();

	const exportFile = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setLoading(true);
		fetchDataForExport(httpClientRaw, endpoint, filters, type, sort, null)
			.then(async (res) => {
				await ensureResponseOk(res);
				const exportFilename = getFilenameFromResponse(res, `${filename || endpoint}.${type}`);
				const blob = await res.blob();
				downloadBlob(blob, exportFilename);
			})
			.catch((err) => {
				notifyError(err);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<ToolbarButton
			disabled={disabled}
			onClick={exportFile}
			icon={loading ? <ProgressIcon /> : <ExportIcon />}
		>
			{label}
		</ToolbarButton>
	);
};

export const ExportServerCSVButton = (props) => (
	<ExportServerButton {...props} type="csv" label="CSV" />
);

export const ExportServerXLSXButton = (props) => (
	<ExportServerButton {...props} type="xlsx" label="XLSX" />
);

export const ExportServerPDFButton = (props) => (
	<ExportServerButton label="PDF" {...props} type="pdf" />
);

export const ExportServerDOCXButton = (props) => (
	<ExportServerButton label="DOCX" {...props} type="docx" />
);
